<template>
    <div id="wrap" class="skpfull_wrap">

        <div class="msg_box">
            <p v-if="pageMode == 'UC'">
                <em>
                    System stabilization is in progress.<br>
                    Please wait a moment. 
                </em>
                <a href="https://www.samsung.com/" class="link" title="Go to Samsung.com Home">Go to Samsung.com Home</a>
            </p>
            <p v-if="pageMode == 'PO'">
                <em>
                    <i>
                    {{$t('MESSAGE.EUR.MOBILE.UC1')}}<br/>
                    {{$t('MESSAGE.EUR.MOBILE.UC2')}}<br/>                    
                    </i>
                </em>
            </p>
        </div>
        
    </div>
</template>

<script>
export default {
    name: 'UnderConstr',
    data() {
        return {
            pageMode : 'UC',
        };
    },
    mounted() {
        this.params = this.$route.query; //
        this.pageMode = this.params.pageMode;
        console.log('this.pageMode ==> ', this.pageMode);
        $('body').addClass('reaair_wrap');
    },
};
</script>
<style scoped></style>



// WEBPACK FOOTER //
// src/skpComponents/view/basis/eur/UnderConstr.vue